
let scrollVal = 0;
    window.addEventListener('scroll',() => {
         let x =   window.scrollY;
         if (x > scrollVal && scrollVal > 18) {
         document.querySelector('.mainHeader').classList.add('fixed');
         document.querySelector('#section-header').classList.remove('Header--transparent');
        } else if (x <= 10) {
            document.querySelector('.mainHeader').classList.remove('fixed');
            document.querySelector('#section-header').classList.add('Header--transparent');
        }
        scrollVal = x;
    }, {passive: true});
    if (window.innerWidth <= 1024) {
        document.querySelector('.wc-product-description-right form select > option' ).textContent = 'SIZE';
    }